export default {
    /** 图标尺寸（default-默认、large-大、small-小） */
    size: "default",
    /** 图标颜色 */
    color: "#333",
    /** 背景色 */
    background: "transparent",
    /** 加载状态图标类型（spin-菊花转转转、point-小点闪闪闪） */
    type: "spin",
    /** 内容居中 */
    center: false,
    /** 铺满父级容器 */
    fix: false,
    /** transition过渡名称 */
    transition: "loading-fade",
    /** 不显示过渡动画 */
    disTransition: false,
    /** 显示遮罩（全屏显示时有效） */
    cover: false,
}
